import React from 'react';
import classnames from 'classnames';

import './Card.scss';

interface Props {
  children: any;
  className?: string;
  withPadding?: boolean;
  isSplit? : boolean;
}

export const Card = (props: Props) => {
  const { className, withPadding, isSplit, children } = props;
  return (
    <div className={classnames('cmp-card', className, { withPadding, isSplit })}>
      {children}
    </div>
  );
}

export const WhiteCard = (props) => (
  <Card {...props} className={classnames(props.className, '_white')} />
);

export const WhiteCardWithWidePadding = (props) => (
  <Card {...props} className={classnames(props.className, '_white', '_wide-padding')} />
);

export const TransparentCard = (props) => (
  <Card {...props} className={classnames(props.className, '_transparent')} />
);

export default Card;
